import React, { useState } from "react";

// import JS files
import Navbar from "../shares/others/Navbar";
import Footer from "../shares/others/Footer";
import Breadcrumb from "../shares/others/Breadcrumb";
import MuiPagination from "../shares/mui/MuiPagination";
import moment from "jalali-moment";

// import others files
import MediaCard from "./MediaCard";
import MobileFilter from "../newsList/MobileFilter";
import Filter from "../newsList/Filter";
import useFetch from "../../context/useFetch";

const breadcrumbList = ["صفحه اصلی", "چندرسانه‌ای"];

const MediaList = (props) => {
  const [newsType, setNewsType] = useState(null);
  const [newsDate, setNewsDate] = useState(null);

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 12,
    count: 0,
  });

  const [newsList, setNewsList] = useState({ results: [] });
  const getNewsListApi = useFetch({
    method: "get",
    params: {
      type: newsType,
      date: newsDate !== null ? moment(newsDate).format("YYYY-MM-DD") : null,
    },
    pagination: paginationPageInfo,
    url: "News_Service/get_multimedia_news_page",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setNewsList(res);
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
  });
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setNewsList({ results: [] });
    getNewsListApi.reFetch();
  };
  const filter_api = () => {
    getNewsListApi.reFetch();
  };
  return (
    <>
      <Navbar active_item="media" />
      <div className="mx-8 2xl:mx-32 mt-8 mb-16">
        <Breadcrumb list={breadcrumbList} />
        <div className="my-4 md:hidden">
          <MobileFilter
            header="چندرسانه‌ای"
            type="media"
            newsType={newsType}
            setNewsType={setNewsType}
            newsDate={newsDate}
            setNewsDate={setNewsDate}
            filter_api={filter_api}
          />
        </div>
        <Filter
          type="media"
          newsType={newsType}
          setNewsType={setNewsType}
          newsDate={newsDate}
          setNewsDate={setNewsDate}
          filter_api={filter_api}
        />
        <div className="my-4  grid md:grid-cols-4 gap-8">
          {newsList.results.map((it, ind) => {
            return [<MediaCard data={it} />];
          })}
        </div>
        <div className="mt-8 flex justify-center">
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MediaList;
